// Working
import "./App.css";
import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Parent from "./JS/HomeScreen/Parent";
import HeaderWithSidePanel from "./JS/HomeScreen/handlebar";
import Footer from "./JS/HomeScreen/Footer";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

// Services
import EducationVerification from "/opt/criterion-screeners-website/cs-frontend/src/JS/Service/EducationVerification";
import AddressVerification from "./JS/Service/AddressVerification";
import EmploymentVerification from "./JS/Service/EmploymentVerification";
import IdVerification from "./JS/Service/IdVerification";
import CriminalBackgroundCheck from "./JS/Service/CriminalBackgroundCheck";
import MoonlightingVerification from "./JS/Service/MoonLightingVerification";
import SocialMediaVerification from "./JS/Service/SocialMediaVerification";
import CibilCheck from "./JS/Service/CibilCheck";
import DrugTestVerification from "./JS/Service/DrugTestVerification";
import ReferenceCheckVerification from "./JS/Service/ReferenceCheckVerification";
import GlobalDatabaseCheck from "./JS/Service/GlobalDatabaseCheck";

// Industry Services
import ItServices from "./JS/Industry Services/ItServices";
import HealthServices from "./JS/Industry Services/HealthServices";
import ECommerceServices from "./JS/Industry Services/ECommerceServices";
import ManufacturingServices from "./JS/Industry Services/ManufacturingServices";
import TelecomServices from "./JS/Industry Services/TelecomServices";
import BankingFinancialServices from "./JS/Industry Services/BankingFinancial";

// Blogs
import Blog from "./JS/Blog";

// footer details:
import Privacy from "./JS/HomeScreen/Privacy_Policy";
import DataPrivacy from "./JS/HomeScreen/Data_Privacy";

import {
  MessageCircle,
  Send,
  XCircle,
} from "lucide-react";
import professionalAvatar from "../../cs-frontend/src/Images/professionalAvatar.png";
import { useNavigate } from "react-router-dom";


// Tracker component to handle page visit tracking
function Tracker({ ip, sessionId, fingerprint }) {
  const location = useLocation();
  const [lastPath, setLastPath] = useState(null);

  useEffect(() => {
    if (ip && sessionId && fingerprint && lastPath !== location.pathname) {
      const pageVisit = {
        path: location.pathname,
        time: new Date().toLocaleString(),
      };

      const data = {
        ip,
        sessionId,
        fingerprint,
        pageVisits: [pageVisit],
      };

      // console.log("Sending data:", data);
      fetch("https://criterionscreeners.com/api/user-details", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          // console.log("Backend Response:", data);
          setLastPath(location.pathname); // Update last path on success
        })
        .catch((err) => console.error("Error sending to backend:", err));
    }
  }, [location, ip, sessionId, fingerprint, lastPath]);

  return null; // This component doesn't render anything
}

function App() {
  const [ip, setIp] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [fingerprint, setFingerprint] = useState(null);

  // Initial user setup
  useEffect(() => {
    const initializeUser = async () => {
      try {
        // Load FingerprintJS
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        const fingerprintId = result.visitorId;

        // Fetch IP and details
        const res = await fetch("https://ipapi.co/json/");
        const data = await res.json();

        const userAgent = navigator.userAgent;
        const browser = /Chrome/i.test(userAgent) ? "Google Chrome" : "Unknown";
        const device = /Mobile|Android|iPhone|iPad|iPod/i.test(userAgent)
          ? "Mobile"
          : "Desktop";
        const screenResolution = `${window.screen.width}x${window.screen.height}`;

        // Generate or retrieve session ID
        let currentSessionId = localStorage.getItem("sessionId");
        if (!currentSessionId) {
          currentSessionId = Math.random().toString(36).substring(2, 15);
          localStorage.setItem("sessionId", currentSessionId);
        }

        const initialData = {
          email: "guest@example.com", // Replace with auth logic if needed
          ip: data.ip,
          city: data.city || "Unknown",
          region: data.region || "Unknown",
          country: data.country_name || "Unknown",
          timezone: data.timezone || "Unknown",
          isp: data.org || "Unknown",
          browser,
          device,
          screenResolution,
          timeViewed: new Date().toLocaleString(),
          sessionId: currentSessionId,
          fingerprint: fingerprintId,
          pageVisits: [{ path: "/", time: new Date().toLocaleString() }],
        };

        // console.log("Sending initial data:", initialData);
        await fetch("https://criterionscreeners.com/api/user-details", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(initialData),
        })
          .then((res) => res.json())
          // .then((data) => console.log("Initial Backend Response:", data));
          .then((data) => console.log("dummy"));


        setIp(data.ip);
        setSessionId(currentSessionId);
        setFingerprint(fingerprintId);
      } catch (error) {
        console.error("Error initializing user:", error);
      }
    };

    initializeUser();
  }, []); // Runs once on mount



  // Security
  // Right click
  useEffect(() => {
    const disableRightClick = (event) => event.preventDefault();
    document.addEventListener("contextmenu", disableRightClick);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);
  useEffect(() => {
    // Disable Copy & Cut
    const disableCopyCut = (event) => event.preventDefault();
    document.addEventListener("copy", disableCopyCut);
    document.addEventListener("cut", disableCopyCut);

    return () => {
      document.removeEventListener("copy", disableCopyCut);
      document.removeEventListener("cut", disableCopyCut);
    };
  }, []);

  // ❌ Disable Ctrl + S, Ctrl + P, PrintScreen, Developer Tools
  const disableKeys = (event) => {
    if (
      (event.ctrlKey && ["s", "p", "u", "j", "i"].includes(event.key.toLowerCase())) || // Ctrl + S, Ctrl + P, Ctrl + U (View Source), Ctrl + Shift + I/J
      (event.metaKey && ["s", "p"].includes(event.key.toLowerCase())) || // Cmd + S, Cmd + P (macOS)
      event.key === "F12" || // F12 (DevTools)
      (event.ctrlKey && event.shiftKey && ["i", "j", "c"].includes(event.key.toLowerCase())) // Ctrl + Shift + I/J/C
    ) {
      event.preventDefault();
      // alert("This action is disabled!");
    }
  };
  document.addEventListener("keydown", disableKeys);

  // ❌ Disable Print Screen Key (Windows/Linux)
  const disablePrintScreen = (event) => {
    if (event.key === "PrtSc") {
      event.preventDefault();
      // alert("Screenshots are disabled!");
    }
  };
  document.addEventListener("keydown", disablePrintScreen);

  // ❌ Disable macOS Screenshot Shortcuts
  const disableMacScreenshot = (event) => {
    if (
      (event.metaKey && event.shiftKey && ["3", "4", "5"].includes(event.key)) // Cmd + Shift + 3/4/5
    ) {
      event.preventDefault();
      // alert("Screenshots are disabled on this site!");
    }
  };
  document.addEventListener("keydown", disableMacScreenshot);

  // ❌ Prevent Mobile Screenshots (Android & iOS)
  const disableMobileScreenshot = () => {
    document.body.style.display = "none"; // Temporary hide page when screenshot is attempted
    setTimeout(() => {
      document.body.style.display = "block";
    }, 1000);
  };
  window.addEventListener("visibilitychange", () => {
    if (document.hidden) disableMobileScreenshot();
  });

  // Screen Recording
  useEffect(() => {
    let lastTime = performance.now();
    let frames = 0;
  
    const detectScreenRecording = () => {
      let currentTime = performance.now();
      frames++;
  
      if (currentTime - lastTime >= 1000) {
        if (frames < 10) {
          // alert("Screen recording detected! This is not allowed.");
        }
        frames = 0;
        lastTime = currentTime;
      }
  
      requestAnimationFrame(detectScreenRecording);
    };
  
    detectScreenRecording();
  }, []);


  // Chat Bot
  function Chatbot() {
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [messages, setMessages] = useState([
      {
        text: "Hello! I'm your Criterion Assistant. How can I help you today? Ask about our services or industries!",
        isBot: true,
      },
    ]);
    const [input, setInput] = useState("");
    const navigate = useNavigate();
  
    const handleSendMessage = () => {
      if (input.trim() === "") return;
  
      setMessages([...messages, { text: input, isBot: false }]);
      const lowerInput = input.toLowerCase();
  
      setTimeout(() => {
        let response =
          "I'm not sure how to help with that. Could you ask about our services or industries?";
        let shouldNavigate = false;
        let path = "";
  
        // Expanded logic based on the Excel sheet
        if (lowerInput.includes("education") || lowerInput.includes("degree")) {
          response =
            "Would you like to know more about Education Verification? I can take you there!";
          shouldNavigate = true;
          path = "/education-verification";
        } else if (
          lowerInput.includes("address") ||
          lowerInput.includes("location")
        ) {
          response = "Interested in Address Verification? Let me show you!";
          shouldNavigate = true;
          path = "/address-verification";
        } else if (
          lowerInput.includes("employment") ||
          lowerInput.includes("job")
        ) {
          response = "Want to explore Employment Verification? Here you go!";
          shouldNavigate = true;
          path = "/employment-verification";
        } else if (lowerInput.includes("id") || lowerInput.includes("identity")) {
          response = "ID Verification details coming right up!";
          shouldNavigate = true;
          path = "/id-verification";
        } else if (
          lowerInput.includes("criminal") ||
          lowerInput.includes("background")
        ) {
          response = "Learn about Criminal Background Checks here!";
          shouldNavigate = true;
          path = "/criminal-background-check";
        } else if (lowerInput.includes("moonlighting")) {
          response = "Moonlighting Verification info awaits!";
          shouldNavigate = true;
          path = "/moonlighting-verification";
        } else if (
          lowerInput.includes("social media") ||
          lowerInput.includes("online")
        ) {
          response = "Social Media Verification details for you!";
          shouldNavigate = true;
          path = "/social-media-verification";
        } else if (
          lowerInput.includes("cibil") ||
          lowerInput.includes("credit")
        ) {
          response = "CIBIL Check information coming your way!";
          shouldNavigate = true;
          path = "/cibil-check";
        } else if (
          lowerInput.includes("drug") ||
          lowerInput.includes("substance")
        ) {
          response = "Drug Test Verification details here!";
          shouldNavigate = true;
          path = "/drug-test-verification";
        } else if (
          lowerInput.includes("reference") ||
          lowerInput.includes("referee")
        ) {
          response = "Reference Check Verification info for you!";
          shouldNavigate = true;
          path = "/reference-check-verification";
        } else if (
          lowerInput.includes("global") ||
          lowerInput.includes("international")
        ) {
          response = "Global Database Check details await!";
          shouldNavigate = true;
          path = "/global-database-check";
        } else if (
          lowerInput.includes("it") ||
          lowerInput.includes("tech") ||
          lowerInput.includes("technology")
        ) {
          response = "Interested in IT Services? Let's go there!";
          shouldNavigate = true;
          path = "/it-services";
        } else if (
          lowerInput.includes("health") ||
          lowerInput.includes("healthcare")
        ) {
          response = "Health Services info coming up!";
          shouldNavigate = true;
          path = "/health-services";
        } else if (
          lowerInput.includes("ecommerce") ||
          lowerInput.includes("e-commerce")
        ) {
          response = "E-Commerce Services details for you!";
          shouldNavigate = true;
          path = "/ecommerce-services";
        } else if (lowerInput.includes("manufacturing")) {
          response = "Manufacturing Services info awaits!";
          shouldNavigate = true;
          path = "/manufacturing-services";
        } else if (
          lowerInput.includes("telecom") ||
          lowerInput.includes("telecommunications")
        ) {
          response = "Telecom Services details coming your way!";
          shouldNavigate = true;
          path = "/telecom-services";
        } else if (
          lowerInput.includes("banking") ||
          lowerInput.includes("financial")
        ) {
          response = "Banking & Financial Services info here!";
          shouldNavigate = true;
          path = "/banking-services";
        } else if (
          lowerInput.includes("blog") ||
          lowerInput.includes("articles")
        ) {
          response = "Want to check out our Blogs? Let's go!";
          shouldNavigate = true;
          path = "/blogs";
        } else if (
          lowerInput.includes("who are you") ||
          lowerInput.includes("about")
        ) {
          response =
            "We are Criterion Screeners, a leading background verification company helping businesses unlock real insights about Partners, Employees, Customers, and Users.";
        } else if (
          lowerInput.includes("contact") ||
          lowerInput.includes("reach out")
        ) {
          response =
            "You can reach us at our Corporate Office: Innovator Building, ITPL, Whitefield Road, Bengaluru, Karnataka - 560066, or our Branch Office: Ardente Office One, Hoodi, Bengaluru, Karnataka - 560048. You can also call us on 📞 +91 80711 88588 || +91 40452 09581";
        } else if (
          lowerInput.includes("why choose you") ||
          lowerInput.includes("benefits")
        ) {
          response =
            "We provide fast, accurate, and reliable verification services tailored to your industry, ensuring trust and compliance.";
        } else if (
          lowerInput.includes("pricing") ||
          lowerInput.includes("cost")
        ) {
          response =
            "Pricing depends on the service and volume. Contact us for a customized quote!";
        } else if (
          lowerInput.includes("how long") ||
          lowerInput.includes("time")
        ) {
          response =
            "Verification times vary by service—typically 1-5 days. Want details on a specific one?";
        } else if (
          lowerInput.includes("login") ||
          lowerInput.includes("sign in")
        ) {
          response =
            "You can log in at https://app.attest360.com/bgv/login. Want me to take you there?";
          shouldNavigate = true;
          path = "https://app.attest360.com/bgv/login";
        } else if (
          lowerInput.includes("what do you do") ||
          lowerInput.includes("services")
        ) {
          response =
            "We offer background verification services like Education, Employment, Criminal Checks, and more. Ask me about any specific service!";
        } else if (
          lowerInput.includes("industries") ||
          lowerInput.includes("sectors")
        ) {
          response =
            "We serve IT, Healthcare, E-Commerce, Manufacturing, Telecom, Banking, and more. Which one interests you?";
        } else if (
          lowerInput.includes("compliance") ||
          lowerInput.includes("legal")
        ) {
          response =
            "Our services ensure compliance with local and international regulations. Want to know more about a specific check?";
        } else if (
          lowerInput.includes("support") ||
          lowerInput.includes("help")
        ) {
          response =
            "Need help? Contact us at our offices or ask me about any service!";
        } else if (
          lowerInput.includes("jobs") ||
          lowerInput.includes("careers")
        ) {
          response =
            "Looking for a career with us? Check our LinkedIn for openings!";
          shouldNavigate = true;
          path = "https://www.linkedin.com/company/criterion-screeners";
        } else if (
          lowerInput.includes("partners") ||
          lowerInput.includes("collaboration")
        ) {
          response =
            "We work with businesses to verify Partners. Interested in partnering with us?";
        } else if (
          lowerInput.includes("customers") ||
          lowerInput.includes("clients")
        ) {
          response =
            "We help businesses verify their Customers for trust and safety. Ask me how!";
        }
  
        setMessages((prev) => [...prev, { text: response, isBot: true }]);
        if (shouldNavigate) {
          setTimeout(() => {
            if (path.startsWith("http")) {
              window.location.href = path; // External link
              window.scrollTo(0, 0); // Scroll to top for external links
            } else {
              navigate(path, { replace: false }); // Internal route
              window.scrollTo(0, 0); // Scroll to top immediately after navigation
              setIsChatOpen(false);
            }
          }, 1500);
        }
      }, 1000);
  
      setInput("");
    };
  
    return (
      <>
        <style>
          {`
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(20px); }
              to { opacity: 1; transform: translateY(0); }
            }
            @keyframes bounce {
              0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
              40% { transform: translateY(-10px); }
              60% { transform: translateY(-5px); }
            }
            .animate-fadeIn { animation: fadeIn 0.3s ease-out; }
            .animate-bounce { animation: bounce 2s infinite; }
            .typing::after {
              content: '...';
              animation: blink 1s infinite;
            }
            @keyframes blink {
              50% { opacity: 0; }
            }
          `}
        </style>
        <div className="fixed bottom-6 right-6 z-50">
          {!isChatOpen && (
            <button
              onClick={() => setIsChatOpen(true)}
              className="bg-[#C4392A] text-white p-4 rounded-full shadow-lg hover:bg-[#2B54D5] transition-all duration-300 transform hover:scale-105 animate-bounce"
            >
              <MessageCircle size={24} />
            </button>
          )}
  
          {isChatOpen && (
            <div className="w-80 h-[500px] bg-white rounded-lg shadow-2xl flex flex-col overflow-hidden animate-fadeIn">
              <div className="bg-[#C4392A] text-white p-4 flex justify-between items-center">
                <div className="flex items-center gap-2">
                  <img
                    src={professionalAvatar} // New professional avatar
                    alt="Bot Avatar"
                    className="w-8 h-8 rounded-full"
                  />
                  <h3 className="font-semibold">Criterion Assistant</h3>
                </div>
                <button
                  onClick={() => setIsChatOpen(false)}
                  className="hover:text-gray-200 transition-colors"
                >
                  <XCircle size={20} />
                </button>
              </div>
  
              <div className="flex-1 p-4 overflow-y-auto bg-gray-50">
                {messages.map((msg, index) => (
                  <div
                    key={index}
                    className={`mb-3 flex ${
                      msg.isBot ? "justify-start" : "justify-end"
                    }`}
                  >
                    {msg.isBot && (
                      <img
                        src={professionalAvatar} // New professional avatar
                        alt="Bot Avatar"
                        className="w-6 h-6 rounded-full mr-2 self-end"
                      />
                    )}
                    <div
                      className={`max-w-[70%] p-3 rounded-lg ${
                        msg.isBot
                          ? "bg-[#2B54D5] text-white"
                          : "bg-[#C4392A] text-white"
                      }`}
                    >
                      {msg.text}
                    </div>
                  </div>
                ))}
              </div>
  
              <div className="p-4 border-t bg-white">
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
                    placeholder="Type your message..."
                    className="flex-1 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C4392A] text-black bg-white"
                  />
                  <button
                    onClick={handleSendMessage}
                    className="bg-[#C4392A] text-white p-2 rounded-lg hover:bg-[#2B54D5] transition-colors transform hover:scale-105"
                  >
                    <Send size={20} />
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  return (
    <Router>
      {/* Render the HeaderWithSidePanel on every page */}
      <HeaderWithSidePanel />
      {/* Add padding-top to the content to start below the header */}
      <div className="pt-28 lg:pt-20">
        {/* Render Tracker only when ip, sessionId, and fingerprint are available */}
        {ip && sessionId && fingerprint && (
          <Tracker ip={ip} sessionId={sessionId} fingerprint={fingerprint} />
        )}
        <Routes>
          <Route path="/" element={<Parent />} />
          <Route path="/bar" element={<HeaderWithSidePanel />} />
          <Route
            path="/education-verification"
            element={<EducationVerification />}
          />
          <Route
            path="/address-verification"
            element={<AddressVerification />}
          />
          <Route
            path="/employment-verification"
            element={<EmploymentVerification />}
          />
          <Route path="/id-verification" element={<IdVerification />} />
          <Route
            path="/criminal-background-check"
            element={<CriminalBackgroundCheck />}
          />
          <Route
            path="/moonlighting-verification"
            element={<MoonlightingVerification />}
          />
          <Route
            path="/social-media-verification"
            element={<SocialMediaVerification />}
          />
          <Route path="/cibil-check" element={<CibilCheck />} />
          <Route
            path="/drug-test-verification"
            element={<DrugTestVerification />}
          />
          <Route
            path="/reference-check-verification"
            element={<ReferenceCheckVerification />}
          />
          <Route
            path="/global-database-check"
            element={<GlobalDatabaseCheck />}
          />
          <Route path="/it-services" element={<ItServices />} />
          <Route path="/health-services" element={<HealthServices />} />
          <Route path="/ecommerce-services" element={<ECommerceServices />} />
          <Route
            path="/manufacturing-services"
            element={<ManufacturingServices />}
          />
          <Route path="/telecom-services" element={<TelecomServices />} />
          <Route
            path="/banking-services"
            element={<BankingFinancialServices />}
          />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/Data-Privacy" element={<DataPrivacy />} />
        </Routes>
        <Chatbot />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
